var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSimpleN2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#00ac71;}.cls-3{fill:#006240;}.cls-4{fill:#fcfcfc;}.cls-5,.cls-6{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-5{stroke:#00ac71;stroke-width:1.4px;}.cls-6{stroke:#003422;stroke-width:2px;}.cls-7{fill:#fff;opacity:0.502;}.cls-8{fill:#c7c9cb;mix-blend-mode:multiply;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,0q1.47381,0,2.94051.14446t2.91219.432q1.44549.28754,2.85583.71535t2.772.99183q1.36161.564,2.6614,1.25874t2.5252,1.51355q1.22543.81881,2.3647,1.75378T51.2132,8.7868q1.04214,1.04214,1.97711,2.1814t1.75377,2.36469q.8188,1.22542,1.51355,2.52521t1.25875,2.6614q.564,1.36161.99183,2.772t.71534,2.85583q.28753,1.44549.432,2.9122T60,30q0,1.47381-.14446,2.94051t-.432,2.91219q-.28752,1.44549-.71534,2.85583t-.99183,2.772q-.564,1.36161-1.25875,2.6614t-1.51355,2.5252q-.81879,1.22543-1.75377,2.3647T51.2132,51.2132q-1.04214,1.04214-2.1814,1.97711t-2.3647,1.75377q-1.22542.8188-2.5252,1.51355t-2.6614,1.25875q-1.36162.564-2.772.99183t-2.85583.71534q-1.44548.28753-2.91219.432T30,60q-1.47381,0-2.94052-.14446t-2.91219-.432q-1.44549-.28752-2.85583-.71534t-2.772-.99183q-1.36162-.564-2.6614-1.25875t-2.52521-1.51355q-1.22542-.81879-2.36469-1.75377T8.7868,51.2132q-1.04214-1.04214-1.97711-2.1814T5.05591,46.6671q-.81881-1.22542-1.51355-2.5252T2.28361,41.4805q-.564-1.36162-.99182-2.772T.57644,35.8527q-.28752-1.44548-.432-2.91219T0,30q0-1.47381.14446-2.94051t.432-2.9122q.28752-1.44549.71535-2.85583t.99182-2.772q.564-1.36162,1.25875-2.6614t1.51355-2.52521q.81881-1.22542,1.75378-2.36469T8.7868,8.7868q1.04213-1.04214,2.1814-1.97711t2.36469-1.75378q1.22542-.81881,2.52521-1.51355t2.6614-1.25874q1.36161-.564,2.772-.99183T24.14729.57644q1.44549-.28752,2.9122-.432T30,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30,3.02856q1.325,0,2.64364.12988t2.61819.38837q1.29956.25849,2.56752.64313t2.49211.89169q1.22415.50706,2.39271,1.13167t2.27027,1.36075q1.10171.73614,2.126,1.57672t1.96117,1.7775q.93692.93693,1.7775,1.96118t1.57672,2.126q.73614,1.1017,1.36075,2.27027t1.13166,2.39271q.50707,1.22415.8917,2.49211T56.453,24.738q.25849,1.29955.38837,2.61818t.12987,2.64365q0,1.325-.12987,2.64365T56.453,35.26169q-.2585,1.29955-.64313,2.56751t-.8917,2.49212q-.50706,1.22415-1.13166,2.39271T52.42577,44.9843q-.73613,1.10171-1.57671,2.126t-1.77751,1.96117q-.93693.93693-1.96117,1.77751t-2.126,1.57672q-1.1017.73614-2.27026,1.36075t-2.39272,1.13166q-1.22415.50706-2.4921.8917t-2.56752.64313q-1.29955.2585-2.61819.38837T30,56.97114q-1.325,0-2.64365-.12987t-2.61819-.38837q-1.29955-.25851-2.56752-.64313t-2.49211-.8917Q18.45436,54.411,17.2858,53.7864t-2.27027-1.36075q-1.10171-.73614-2.126-1.57671t-1.96118-1.77751q-.93692-.93693-1.7775-1.96117t-1.57672-2.126Q6.838,43.88259,6.21342,42.714T5.08175,40.32131q-.50706-1.22415-.89169-2.49211t-.64313-2.56751q-.2585-1.29956-.38837-2.61819t-.12987-2.64365q0-1.325.12987-2.64365T3.54693,24.738q.25849-1.29955.64313-2.56752t.89169-2.49211q.50706-1.22415,1.13167-2.39271t1.36075-2.27027q.73614-1.1017,1.57672-2.126t1.7775-1.96118q.93693-.93693,1.96118-1.7775t2.126-1.57672q1.10171-.73614,2.27027-1.36075t2.39271-1.13167q1.22415-.50706,2.49211-.89169t2.56752-.64313q1.29955-.25849,2.61819-.38837T30,3.02856Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30,4.25049q1.265,0,2.52388.124t2.49957.37078q1.24069.24678,2.45121.614t2.37921.8513q1.1687.4841,2.28431,1.0804t2.16742,1.2991q1.0518.70278,2.02965,1.50529t1.87233,1.697q.89448.89448,1.697,1.87233t1.50528,2.02964q.7028,1.05181,1.2991,2.16742t1.0804,2.28432q.48411,1.1687.8513,2.37922t.614,2.45119q.24679,1.24069.37078,2.49958t.124,2.52388q0,1.265-.124,2.52389t-.37078,2.49957q-.24679,1.2407-.614,2.45121t-.8513,2.37921q-.48408,1.16869-1.08039,2.28431t-1.2991,2.16742q-.7028,1.0518-1.50529,2.02965t-1.697,1.87233q-.89448.89448-1.87233,1.697t-2.02965,1.50529q-1.0518.70279-2.16742,1.2991t-2.28431,1.0804q-1.16869.4841-2.37921.8513t-2.4512.614q-1.24068.24679-2.49958.37078T30,55.74932q-1.265,0-2.52389-.124t-2.49958-.37078q-1.24068-.24679-2.4512-.614t-2.37921-.8513q-1.1687-.48408-2.28432-1.0804t-2.16741-1.29909q-1.0518-.7028-2.02965-1.50529t-1.87233-1.697q-.89448-.89448-1.697-1.87233T8.59011,44.30551q-.70279-1.0518-1.2991-2.16742t-1.0804-2.28431q-.48409-1.16869-.8513-2.37921t-.614-2.4512q-.24679-1.24068-.37078-2.49958t-.124-2.52389q0-1.265.124-2.52388t.37078-2.49958q.24678-1.24068.614-2.45119t.8513-2.37922q.48408-1.16869,1.0804-2.28432t1.2991-2.16742q.70278-1.05179,1.50529-2.02964t1.697-1.87233q.89448-.89448,1.87233-1.697t2.02965-1.50529q1.05178-.70279,2.16741-1.2991t2.28432-1.0804q1.16869-.48409,2.37921-.8513t2.4512-.614q1.24069-.2468,2.49958-.37078T30,4.25049Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 30.22925,
    y1: 6.15332,
    x2: 30.22925,
    y2: 12.11489
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.02419,
    y1: 13.2998,
    x2: 42.80847,
    y2: 17.51542
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.8465,
    y1: 30.22925,
    x2: 47.88483,
    y2: 30.22925
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 46.69997,
    y1: 47.02425,
    x2: 42.48456,
    y2: 42.80884
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.77075,
    y1: 53.84654,
    x2: 29.77075,
    y2: 47.88477
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.97589,
    y1: 46.69997,
    x2: 17.19128,
    y2: 42.48438
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.15326,
    y1: 29.77075,
    x2: 12.11493,
    y2: 29.77075
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.30005,
    y1: 12.97583,
    x2: 17.51556,
    y2: 17.19135
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 30.22925,
    y1: 17.51563,
    x2: 30.22925,
    y2: 31.23422
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 43.94784,
    y1: 31.23413,
    x2: 30.22925,
    y2: 31.23413
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.444,6.209A23.88649,23.88649,0,0,0,6.00116,30.05061c0,.21764.00352.43425.00931.65023C8.81082,19.556,18.01248,11.42242,28.444,6.209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.0499,20.786c2.47244,26.23811-19.71,34.17883-20.96759,34.779A25.76333,25.76333,0,0,0,54.0499,20.786Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSimpleN2);
export default __webpack_public_path__ + "static/media/ic_simple_n_2.1f0c47d7e20e75f5f45a449f86f10bf3.svg";
export { ForwardRef as ReactComponent };